import { useEffect, useState } from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./selectField.scss";
import { Box } from "@mui/material";

const EditableSelectField = (props: any) => {
  const [options, setOptions] = useState([...props?.options]);

  useEffect(() => {
    setOptions(props?.options);
  }, [props?.options]);

  const filterOptions = createFilterOptions({
  matchFrom: 'start', // This ensures the search only matches from the beginning
})
  
  return (
    <Autocomplete
      disablePortal
      id="searchable-combo-box"
      className={
        "combo-box autocomplete " +
        (props?.disabled
          ? "disabled-dropdown"
          : props?.value === "Select"
          ? "place-holder"
          : "")
      }
      {...props}
      getOptionLabel={(option: any) => (option.label ? option.label : "Select")}
      options={options}
      value={props.value}
      renderOption={(props: any, option: any) => (
        <Box component="li" {...props} key={option.value}>
          {option.label}
        </Box>
      )}
      
      onChange={(event, item) => {
        if (item !== null) {
          props.onChange(item);
        }
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  );
};

export default EditableSelectField;